var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { WellHat } from "@brushfire/ui";
import { Link, useParams } from "react-router-dom";
import Constants from "../../../data/constants";
import { guidsMatch } from "../../../data/helpers";
import { SESSION_STORAGE_KEYS } from "../../../data/sessionStorageHelpers";
var HatType;
(function (HatType) {
    HatType[HatType["none"] = 0] = "none";
    HatType[HatType["myAttendees"] = 1] = "myAttendees";
    HatType[HatType["myOrders"] = 2] = "myOrders";
    HatType[HatType["order"] = 3] = "order";
    HatType[HatType["orderAttendees"] = 4] = "orderAttendees";
    HatType[HatType["group"] = 5] = "group";
    HatType[HatType["groupAttendees"] = 6] = "groupAttendees";
})(HatType || (HatType = {}));
var MyDashboardHat = function (_a) {
    var attendeeList = _a.attendeeList, orders = _a.orders, path = _a.path, currentOrder = _a.currentOrder, currentGroup = _a.currentGroup, email = _a.email, convertRouteParams = _a.convertRouteParams, attendees = _a.attendees, isGroupLeader = _a.isGroupLeader;
    var params = useParams();
    var sessionOrderId = sessionStorage.getItem(SESSION_STORAGE_KEYS.DASHBOARD_ORDER_ID);
    var sessionGroupId = sessionStorage.getItem(SESSION_STORAGE_KEYS.DASHBOARD_GROUP_ID);
    var getHatType = function () {
        var _a;
        if (((_a = attendeeList === null || attendeeList === void 0 ? void 0 : attendeeList.length) !== null && _a !== void 0 ? _a : 0) > 0) {
            if (params.attendeeId) {
                if (sessionOrderId) {
                    return HatType.orderAttendees;
                }
                else if (sessionGroupId) {
                    return HatType.groupAttendees;
                }
                else {
                    switch (path) {
                        case Constants.Routes.myAttendee:
                            return HatType.myAttendees;
                        default:
                            return HatType.myAttendees;
                    }
                }
            }
            else {
                if (params.orderId) {
                    return HatType.order;
                }
                else if (params.groupId) {
                    return HatType.group;
                }
                else if ([Constants.Routes.myDashboard, Constants.Routes.myAttendees].includes(path)) {
                    return HatType.myAttendees;
                }
                else if (path === Constants.Routes.myOrders) {
                    return HatType.myOrders;
                }
            }
        }
        else if (params.orderId) {
            return HatType.order;
        }
        else if (params.groupId) {
            return HatType.group;
        }
        else if ([Constants.Routes.myDashboard, Constants.Routes.myAttendees].includes(path)) {
            return HatType.myAttendees;
        }
        else if (path === Constants.Routes.myOrders) {
            return HatType.myOrders;
        }
        return HatType.none;
    };
    var getHatData = function (hatType) {
        var _a, _b, _c, _d, _e, _f;
        var attendeeNoun = "Attendee".concat(((_a = attendeeList === null || attendeeList === void 0 ? void 0 : attendeeList.length) !== null && _a !== void 0 ? _a : 0) === 1 ? "" : "s");
        var lookupAttendeeNoun = "Attendee".concat(((_b = attendees === null || attendees === void 0 ? void 0 : attendees.length) !== null && _b !== void 0 ? _b : 0) === 1 ? "" : "s");
        var orderNoun = "Order".concat(((_c = orders === null || orders === void 0 ? void 0 : orders.length) !== null && _c !== void 0 ? _c : 0) === 1 ? "" : "s");
        var order = guidsMatch(currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id, params.orderId) || (currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id) === sessionOrderId
            ? currentOrder
            : undefined;
        var group = guidsMatch(currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.id, params.groupId) || (currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.id) === sessionGroupId
            ? currentGroup
            : undefined;
        switch (hatType) {
            case HatType.myAttendees:
                return {
                    title: email ? email : attendeeNoun,
                    linkText: isGroupLeader ? "Manage Group" : "View Orders",
                    to: isGroupLeader
                        ? convertRouteParams(Constants.Routes.myGroup)
                        : ((_d = orders === null || orders === void 0 ? void 0 : orders.length) !== null && _d !== void 0 ? _d : 0) > 0
                            ? convertRouteParams(Constants.Routes.myOrders)
                            : undefined,
                };
            case HatType.myOrders:
                return {
                    title: email ? email : orderNoun,
                    linkText: isGroupLeader ? "Manage Group" : "View Attendees",
                    to: isGroupLeader
                        ? convertRouteParams(Constants.Routes.myGroup)
                        : ((_e = attendees === null || attendees === void 0 ? void 0 : attendees.length) !== null && _e !== void 0 ? _e : 0) > 0
                            ? convertRouteParams(Constants.Routes.myAttendees)
                            : undefined,
                };
            case HatType.orderAttendees:
                if (order) {
                    return {
                        title: "Order ".concat(order === null || order === void 0 ? void 0 : order.orderKey),
                        linkText: "Order Details",
                        to: convertRouteParams(Constants.Routes.myOrder),
                    };
                }
                break;
            case HatType.groupAttendees:
                if (group) {
                    return {
                        title: group === null || group === void 0 ? void 0 : group.name,
                        linkText: "Group Details",
                        to: convertRouteParams(Constants.Routes.myGroup),
                    };
                }
                break;
            case HatType.order:
                if (order) {
                    if (path === Constants.Routes.myOrder) {
                        return {
                            title: "Order ".concat(order === null || order === void 0 ? void 0 : order.orderKey),
                            linkText: "Manage ".concat(lookupAttendeeNoun),
                            to: ((_f = attendeeList === null || attendeeList === void 0 ? void 0 : attendeeList.length) !== null && _f !== void 0 ? _f : 0) > 0
                                ? convertRouteParams(Constants.Routes.myOrderAttendees)
                                : undefined,
                        };
                    }
                    else {
                        return {
                            title: "Order ".concat(order === null || order === void 0 ? void 0 : order.orderKey),
                            linkText: "Order Details",
                            to: convertRouteParams(Constants.Routes.myOrder),
                        };
                    }
                }
                break;
            case HatType.group:
                if (group) {
                    if (path === Constants.Routes.myGroup) {
                        return {
                            title: group === null || group === void 0 ? void 0 : group.name,
                            linkText: "Manage ".concat(lookupAttendeeNoun),
                            to: group.attendeeCount > 0
                                ? convertRouteParams(Constants.Routes.myGroupAttendees)
                                : undefined,
                        };
                    }
                    else {
                        return {
                            title: group === null || group === void 0 ? void 0 : group.name,
                            linkText: "Group Details",
                            to: convertRouteParams(Constants.Routes.myGroup),
                        };
                    }
                }
                break;
            default:
                return undefined;
        }
        return undefined;
    };
    var hatType = getHatType();
    var hatData = getHatData(hatType);
    return (_jsx(_Fragment, { children: !!hatData && (_jsx(WellHat, { title: hatData.title, link: hatData.to ? (_jsx(Link, __assign({ to: hatData.to, className: "ink" }, { children: hatData.linkText }))) : null })) }));
};
export default MyDashboardHat;
